import React from "react";
import "./device.css";

export default function Device() {
  return <div className="device">Device</div>;
}
